(ns dre.pages.db
  (:require
   [dre.i18n.utils :refer [tr-later]]
   [dre.pages.admin.client-download.events :as-alias admin.client-download.events]
   [dre.pages.admin.client-download.views :as admin-client-download]
   [dre.pages.admin.events :as-alias admin.events]
   [dre.pages.admin.feed.db :as admin-feed-db]
   [dre.pages.admin.feed.events :as admin.feed.events]
   [dre.pages.admin.feed.views :as admin-feed]
   [dre.pages.admin.help.events :as-alias admin.help.events]
   [dre.pages.admin.help.views :as admin-help]
   [dre.pages.admin.survey.events :as-alias admin.survey.events]
   [dre.pages.admin.survey.views :as admin-survey]
   [dre.pages.admin.usage.events :as-alias admin.usage.events]
   [dre.pages.admin.usage.views :as admin-usage]
   [dre.pages.admin.ai-summarization-usage.events :as-alias admin.ai-summarization-usage.events]
   [dre.pages.admin.ai-summarization-usage.views :as admin-ai-summarization-usage]
   [dre.pages.annotator.views :as annotator]
   [dre.pages.detail.views :as detail]
   [dre.pages.dictionary.views :as dictionary]
   [dre.pages.dictionary.events :as dictionary.events]
   [dre.pages.frontpage.db :as frontpage-db]
   [dre.pages.frontpage.views :as frontpage]
   [dre.pages.my-searches.views :as my-searches]
   [dre.pages.my-searches.signals.views :as signals]
   [dre.pages.my-searches.tags.views :as tags]
   [dre.pages.my-searches.search-history.views :as search-history]
   [dre.pages.not-found.views :as not-found]
   [dre.pages.pubmed-compare.views :as pubmed-compare]
   [dre.pages.pubmed-compare.events :as pubmed-compare.events]
   [dre.pages.search.views :as search]
   [dre.pages.shared.views :as shared]
   [dre.pages.videos.views :as videos]
   [dre.utils :as utils]))


(def registry
  [{:id :not-found
    :title (tr-later "Not found")
    :view not-found/view}
   {:id :frontpage
    :title "Literature Search"
    :view frontpage/view
    :init-db frontpage-db/init-db
    :init-fx :dre.pages.frontpage.events/init}
   {:id :search
    :title (tr-later "Results")
    :view search/view
    :init-fx :dre.pages.search.events/init}
   {:id :detail
    :title (tr-later "Detail")
    :view detail/view
    :init-fx :dre.pages.detail.events/init}
   {:id :my-searches
    :title (tr-later "Saved")
    :init-fx :dre.pages.my-searches.events/init
    :view my-searches/view}
   {:id :signals
    :title (tr-later "Saved Searches")
    :init-fx :dre.pages.my-searches.signals.events/fetch
    :view signals/view}
   {:id :tags
    :title (tr-later "Tags")
    :init-fx :dre.pages.my-searches.tags.events/fetch
    :view tags/view}
   {:id :search-history
    :title (tr-later "Search History")
    :init-fx :dre.pages.my-searches.search-history.events/fetch
    :view search-history/view}
   {:id :shared
    :title (tr-later "Shared")
    :init-fx :dre.pages.shared.events/init
    :view shared/view}
   {:id :annotator
    :title (tr-later "Annotator")
    :view annotator/view}
   {:id :dictionary
    :title (tr-later "Dictionary")
    :view dictionary/view
    :init-fx ::dictionary.events/init}
   {:id :videos
    :title (tr-later "Videos")
    :view videos/view}
   {:id :admin
    :title (tr-later "Admin")
    :view (fn [] [:div nil])
    :init-fx ::admin.events/init
    :permission-fx (fn [user] (or (utils/admin-role? user)
                                  (utils/sanofi-csv-export-role? user)
                                  utils/localhost?))}
   {:id :admin-help
    :title (tr-later "Admin - Help Settings")
    :init-fx ::admin.help.events/init
    :view admin-help/view
    :permission-fx (fn [user] (or (utils/admin-role? user)
                                  (utils/sanofi-csv-export-role? user)
                                  utils/localhost?))}
   {:id :admin-feed
    :title (tr-later "Admin - Feed Settings")
    :init-db admin-feed-db/init-db
    :init-fx ::admin.feed.events/init
    :view admin-feed/view
    :permission-fx (fn [user] (or (utils/admin-role? user)
                                  (utils/sanofi-csv-export-role? user)
                                  utils/localhost?))}
   {:id :admin-survey
    :title (tr-later "Admin - Surveys")
    :init-fx ::admin.survey.events/init
    :view admin-survey/view
    :permission-fx (fn [user] (or (utils/admin-role? user)
                                  (utils/sanofi-csv-export-role? user)
                                  utils/localhost?))}
   {:id :admin-usage
    :title (tr-later "Admin - Usage Reports")
    :init-fx ::admin.usage.events/init
    :view admin-usage/view
    :permission-fx (fn [user] (or (utils/admin-role? user)
                                  (utils/sanofi-csv-export-role? user)
                                  utils/localhost?))}
   {:id :admin-ai-summarization-usage
    :title (tr-later "Admin - AI Summarization Usage")
    :init-fx ::admin.ai-summarization-usage.events/init
    :view admin-ai-summarization-usage/view
    :permission-fx (fn [user] (or (utils/admin-role? user)
                                  utils/localhost?))}
   {:id :admin-client-download
    :title (tr-later "Admin - Client Downloads")
    :init-fx ::admin.client-download.events/init
    :view admin-client-download/view
    :permission-fx (fn [user] (or (utils/admin-role? user)
                                  (utils/sanofi-csv-export-role? user)
                                  utils/localhost?))}
   {:id :pubmed-compare
    :title (tr-later "PubMed Compare")
    :view pubmed-compare/view
    :init-fx ::pubmed-compare.events/init
    :permission-fx (fn [user] (or
                               (utils/admin-role? user)
                               utils/localhost?))}])


(def index (into {} (map (juxt :id identity)) registry))
